// ----------------------------------------------------------------------
// <copyright file="Izenda.VirtualListItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var PropTypes = React.PropTypes;
  const { get, identity, flow, debounce } = require('lodash/fp');
  var VirtualListItem = React.createClass({
    propTypes: {
      children: PropTypes.element,
      item: PropTypes.object,
      onSyncCoordinates: PropTypes.any
    },
    updateFunction: function(props) {
      this.childDidUpdate = get('didUpdate', props.children) || identity;
      this.debounceSyncCoord = debounce(360, flow(this.syncCoords, this.childDidUpdate));
    },
    componentWillMount: function() {
      this.updateFunction(this.props);
      this.didMount = false;
    },
    componentWillReceiveProps: function(nextProps) {
      this.updateFunction(nextProps);
    },
    componentDidMount: function() {
      this.didMount = true;
      this.syncCoords();
    },
    componentWillUnmount: function() {
      this.didMount = false;
      this.debounceSyncCoord.cancel();
    },
    render: function() {
      return React.cloneElement(this.props.children, {
        isTrainingMode: get('item.isTrainingMode', this.props),
        didUpdate: this.debounceSyncCoord
      });
    },
    syncCoords: function() {
      const { props } = this;
      const { onSyncCoordinates } = props;

      const domNode = this.didMount && ReactDOM.findDOMNode(this);
      if (domNode) {
        onSyncCoordinates && onSyncCoordinates(domNode);
      }
    }
  });

  module.exports = VirtualListItem;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.VirtualListItem.jsx